export function getLocalStorage() {
	return (window.localStorage.getItem('userInfo'))?(JSON.parse(window.localStorage.getItem('userInfo'))):''
}

export function setLocalStorage(userInfo) {
	if(userInfo){
		return window.localStorage.setItem('userInfo',JSON.stringify(userInfo))
	}else {
		return window.localStorage.setItem('userInfo',undefined)
	}

}

export function setToken(token) {
	return window.localStorage.setItem('token',token)
}

export function getToken() {
	return ('bearer ' + window.localStorage.getItem('token'))
}

export function baseUrl() {
	return 'http://zb.gnszkj.com/'
	// return 'http://10.10.45.50:8001/api/'	// 长沙师范学院 内部域名
	// return 'http://10.0.13.90:8001/api/'	// 广东技术师范大学 内部域名
}

export function version() {
	return '1.0.5'
	// return 'http://10.0.0.172:1204/'
}



// WEBPACK FOOTER //
// ./src/utils/auth.js